import {
  takeLatest, all, call, put, select, delay,
} from 'redux-saga/effects';

import { saveAs } from 'file-saver';

import { notification } from '@anna/anna-ws-ui';
import {
  apiRequestCSV,
  apiRequestCSVCheckStatus,
  apiGetCSV,
} from './api';

import {
  requestCSVActionTypes,
  requestCSVActions,
  requestCSVCheckStatusActions,
  requestCSVCheckStatusActionTypes,
  downloadCSVActions,
  downloadCSVActionTypes,
} from './actions';

const getAccountId = (state) => state.accountService.account.id;
const getCompanyId = (state) => state.appService.companyId;

function* requestCSV({ format }) {
  try {
    yield put(requestCSVActions.request(format));

    const accountId = yield select(getAccountId);
    const dates = yield select((state) => state.transactionsService.dates);
    const companyId = yield select(getCompanyId);

    const response = yield call(() => apiRequestCSV(companyId, accountId, format, dates));
    const responseJson = yield response.json();
    yield put(requestCSVActions.success(responseJson.data.id));
  } catch (error) {
    console.error(error);
    yield put(requestCSVActions.error(error));
  }
}

function* requestCSVCheckStatus() {
  try {
    yield put(requestCSVCheckStatusActions.request());

    const accountId = yield select(getAccountId);
    const requestId = yield select((state) => state.downloadTransactionsCSVService.requestId);
    const companyId = yield select(getCompanyId);

    const response = yield call(() => apiRequestCSVCheckStatus(companyId, accountId, requestId));
    const responseJson = yield response.json();
    if (responseJson.data.status === 'ready') {
      const fileId = responseJson.data.url.split('/').pop();
      yield put(downloadCSVActions.common(fileId));
    } else if (responseJson.data.status === 'failed') {
      notification.error('Can’t download file.');
      yield put(downloadCSVActions.error());
    } else {
      yield delay(2000);
      yield put(requestCSVCheckStatusActions.common());
    }
    yield put(requestCSVCheckStatusActions.success());
  } catch (error) {
    console.error(error);
    yield put(requestCSVCheckStatusActions.error(error));
  }
}

function* downloadCSV(action) {
  try {
    yield put(downloadCSVActions.request());

    const { downloadUrl } = action;
    const companyId = yield select(getCompanyId);
    const response = yield call(() => apiGetCSV(companyId, downloadUrl));
    const responseBlob = yield response.blob();
    const blob = new Blob([responseBlob]);
    saveAs(blob, 'transactions.csv');
    yield put(downloadCSVActions.success());
  } catch (error) {
    console.error(error);
    yield put(downloadCSVActions.error(error));
  }
}

function* watchRequestCSV() {
  yield takeLatest(requestCSVActionTypes.common, requestCSV);
}

function* watchRequestCSVCheckStatus() {
  yield takeLatest(requestCSVCheckStatusActionTypes.common, requestCSVCheckStatus);
}

function* watchDownloadCSV() {
  yield takeLatest(downloadCSVActionTypes.common, downloadCSV);
}

export default function* root() {
  yield all([
    watchRequestCSV(),
    watchRequestCSVCheckStatus(),
    watchDownloadCSV(),
  ]);
}
